// removed by extract-text-webpack-plugin
module.exports = {"header":"header___3wuU4","back":"back___1tHoc","flip-buttons":"flip-buttons___1vQW6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/HeaderForm.module.scss
// module id = 2205
// module chunks = 0